import { useCallback } from "react";
import { useAppData } from "../../contexts/appData.context";
import { useRequest } from "../useRequest.hook";
import { FetchOptions } from "../../interfaces/fetchOptions.interface";
import { DA_Notification } from "../../interfaces/notification.interface";

type GetHeaderNotifications = (
    getRead?: boolean,
    get90Days?: boolean,
    options?: FetchOptions
) => Promise<DA_Notification[]>;

export const useHeaderNotificationsApi = () => {
    const { customerNumber } = useAppData();
    const request = useRequest();

    const getHeaderNotifications: GetHeaderNotifications = useCallback(
        (getRead, get90Days, options) =>
            request
                .get(`headernotifications/${customerNumber}`, { getRead, get90Days }, options)
                .then((response) => response),
        [request, customerNumber]
    );

    return {
        getHeaderNotifications,
    };
};
